import React from 'react';
import { InlinePRConfig } from '@nykaa/sitewide-prices-revealed/inlinePriceReveal/types';
import LoadableView from './Loadable';

interface PriceRevealProps {
  inlinePRConfig: InlinePRConfig;
}

function View({ inlinePRConfig }: PriceRevealProps) {
  if (inlinePRConfig) {
    const { isActive } = inlinePRConfig;
    if (isActive) {
      return <LoadableView />;
    }
  }
  return null;
}

export default View;
